import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  ConfigProvider,
  DatePicker,
  Select,
  Upload,
  Spin,
  Modal,
  message,
} from "antd";
import { IoMdArrowDropdown } from "react-icons/io";
import dayjs from "dayjs";
import { FaUpload } from "react-icons/fa";
import { MdDelete, MdEdit } from "react-icons/md";

import {
  GetDocumentById,
  UploadDocument,
  GetDocumentsData,
  ValidateUpdateDocumentOtp,

  GetAllDocumentCategory,
  GetDocumentCategoryById,
  AddDocumentCategory,
  UpdateDocumentCategory,
  DeleteDocumentCategory,

  GetAllDocumentSubCategory,
  GetDocumentSubCategoryById,
  AddDocumentSubCategory,
  UpdateDocumentSubCategory,
  DeleteDocumentSubCategory,
  GetAllCategoryDropdown,
} from "../../../Api/SuperAdminVault/Documents";

import DocumentOtpModal from "./DocumentOtpModal";

const { Dragger } = Upload;

const CATEGORY_LIMIT = 10;
const SUB_CATEGORY_LIMIT = 10;

const DocumentForm = ({
  documentId,
  mode,
  setModalIsOpen,
  onSuccess,
  currentFilter,
}) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);

  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [pendingPayload, setPendingPayload] = useState(null);

  const [categories, setCategories] = useState([]);
  const [categoryPage, setCategoryPage] = useState(1);
  const [categoryHasMore, setCategoryHasMore] = useState(false);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [categorySearch, setCategorySearch] = useState("");
  const [categoryByIdLoading, setCategoryByIdLoading] = useState(false);

  const [subCategories, setSubCategories] = useState([]);
  const [subCategoryPage, setSubCategoryPage] = useState(1);
  const [subCategoryHasMore, setSubCategoryHasMore] = useState(false);
  const [subCategoryLoading, setSubCategoryLoading] = useState(false);
  const [subCategorySearch, setSubCategorySearch] = useState("");
  const [subCategoryByIdLoading, setSubCategoryByIdLoading] = useState(false);

  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const [subCategoryModalOpen, setSubCategoryModalOpen] = useState(false);

  const [editingCategory, setEditingCategory] = useState(null);
  const [editingSubCategory, setEditingSubCategory] = useState(null);

  const [categoryForm, setCategoryForm] = useState({
    category_name: "",
    category_code: "",
    description: "",
    is_active: true,
  });

  const [subCategoryForm, setSubCategoryForm] = useState({
    category_id: "",
    subcategory_name: "",
    subcategory_code: "",
    description: "",
    is_active: true,
  });

  const [formValues, setFormValues] = useState({
    document: null,
    categoryName:"",
    subCategoryName:"",
    category_id: "",
    subcategory_id: null,
    is_sensitive: false,
    expires_at: null,
    description: "",
  });

  const [existingFileName, setExistingFileName] = useState("");
  const [errors, setErrors] = useState({});

  const selectTheme = {
    components: {
      Select: {
        optionActiveBg: "#aebed1",
        optionSelectedColor: "#1F487C",
        optionSelectedBg: "#e5e5e5",
        optionHeight: 28,
      },
    },
  };

  const selectClassName =
    "custom-select bg-white outline-none w-full mt-[0.5vw] h-[3vw] text-[1.1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.5vw] border-r-[0.25vw] border-b-[0.25vw]";

  const inputClass =
    "box-border border-r-[0.18vw] mt-[0.12vw] border-l-[0.08vw] border-t-[0.08vw] border-b-[0.18vw] border-[#1F487C] text-[#1F487C] text-[0.78vw] h-[2.3vw] w-full rounded-[0.3vw] outline-none px-[0.55vw] placeholder:text-[0.95vw] placeholder:font-sans";

  const selectClass =
    "umselect custom-select bg-white outline-none w-full mt-[0.12vw] h-[2.3vw] text-[0.75vw] border-[#1F4B7F] border-l-[0.08vw] border-t-[0.08vw] rounded-[0.3vw] border-r-[0.18vw] border-b-[0.18vw] placeholder:text-[0.80vw]";

  useEffect(() => {
    fetchCategories(1, "", true);
    fetchSubCategories(1, "", true);
  }, []);

  useEffect(() => {
    if (mode === "edit" && documentId) {
      fetchDocumentById();
    }
  }, [documentId, mode]);

  const getCategoryId = (item) => item?.category_id || "";
  const getCategoryName = (item) => item?.category_name || "";

  const getSubCategoryId = (item) =>
    item?.subcategory_id || item?.sub_category_id || item?.id || "";

  const getSubCategoryName = (item) =>
    item?.subcategory_name || item?.sub_category_name || "";

  const getResponseData = (result) => result?.data || result;

  const addCategoryIfMissing = (categoryData) => {
    if (!categoryData?.category_id) return;

    setCategories((prev) => {
      const exists = prev.some(
        (item) => String(item.category_id) === String(categoryData.category_id)
      );

      if (exists) return prev;

      return [categoryData, ...prev];
    });
  };

  const addSubCategoryIfMissing = (subCategoryData) => {
    const id = getSubCategoryId(subCategoryData);

    if (!id) return;

    setSubCategories((prev) => {
      const exists = prev.some(
        (item) => String(getSubCategoryId(item)) === String(id)
      );

      if (exists) return prev;

      return [subCategoryData, ...prev];
    });
  };

  const ensureCategoryLoaded = async (categoryId) => {
    if (!categoryId) return;

    let pageNo = 1;
    let hasMore = true;

    while (hasMore) {
      const result = await GetAllDocumentCategory({
        page: pageNo,
        limit: CATEGORY_LIMIT,
        search: "",
        sort_column: "category_id",
        sort_order: "DESC",
      });

      const list = Array.isArray(result?.data) ? result.data : [];
      const matched = list.find(
        (item) => String(item.category_id) === String(categoryId)
      );

      if (matched) {
        addCategoryIfMissing(matched);
        return;
      }

      hasMore = Boolean(result?.pagination?.has_more_page);
      pageNo += 1;
    }
  };

  const ensureSubCategoryLoaded = async (subcategoryId) => {
    if (!subcategoryId) return;

    let pageNo = 1;
    let hasMore = true;

    while (hasMore) {
      const result = await GetAllDocumentSubCategory({
        page: pageNo,
        limit: SUB_CATEGORY_LIMIT,
        search: "",
        sort_column: "subcategory_id",
        sort_order: "DESC",
      });

      const list = Array.isArray(result?.data) ? result.data : [];
      const matched = list.find(
        (item) => String(getSubCategoryId(item)) === String(subcategoryId)
      );

      if (matched) {
        addSubCategoryIfMissing(matched);
        return;
      }

      hasMore = Boolean(result?.pagination?.has_more_page);
      pageNo += 1;
    }
  };

const isDropdownBottom = (event) => {
  const target = event.target;

  return (
    target.scrollTop + target.clientHeight >= target.scrollHeight - 5
  );
};

  const fetchCategories = async (pageNo = 1, searchText = "", reset = false) => {
    if (categoryLoading) return;

    setCategoryLoading(true);

    try {
      const result = await GetAllDocumentCategory({
        page: pageNo,
        limit: CATEGORY_LIMIT,
        search: searchText,
        sort_column: "category_id",
        sort_order: "DESC",
      });

      const list = Array.isArray(result?.data) ? result.data : [];

      setCategories((prev) => {
        if (reset) return list;

        const oldIds = new Set(prev.map((item) => String(item.category_id)));
        const newList = list.filter(
          (item) => !oldIds.has(String(item.category_id))
        );

        return [...prev, ...newList];
      });

      setCategoryPage(Number(result?.pagination?.page || pageNo));
      setCategoryHasMore(Boolean(result?.pagination?.has_more_page));
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch categories");
    } finally {
      setCategoryLoading(false);
    }
  };

  const fetchSubCategories = async (
    pageNo = 1,
    searchText = "",
    reset = false
  ) => {
    if (subCategoryLoading) return;

    setSubCategoryLoading(true);

    try {
      const result = await GetAllDocumentSubCategory({
        page: pageNo,
        limit: SUB_CATEGORY_LIMIT,
        search: searchText,
        sort_column: "subcategory_id",
        sort_order: "DESC",
      });

      const list = Array.isArray(result?.data) ? result.data : [];

      setSubCategories((prev) => {
        if (reset) return list;

        const oldIds = new Set(
          prev.map((item) => String(getSubCategoryId(item)))
        );
        const newList = list.filter(
          (item) => !oldIds.has(String(getSubCategoryId(item)))
        );

        return [...prev, ...newList];
      });

      setSubCategoryPage(Number(result?.pagination?.page || pageNo));
      setSubCategoryHasMore(Boolean(result?.pagination?.has_more_page));
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch sub categories");
    } finally {
      setSubCategoryLoading(false);
    }
  };

const fetchDocumentById = async () => {
  setFetchLoading(true);

  try {
    const data = await GetDocumentById(documentId);

    if (data) {
      const isDeletedCategory = data.categoryName === "deleted_category";
      const isDeletedSubCategory =
        data.subCategoryName === "deleted_subcategory";

      const categoryId =
        !isDeletedCategory && data.category_id
          ? String(data.category_id)
          : "";

      const subCategoryId =
        !isDeletedSubCategory && data.subcategory_id
          ? String(data.subcategory_id)
          : "";

      setExistingFileName(data.original_file_name || "");

      setFormValues({
        document: null,
        categoryName: isDeletedCategory ? "" : data.categoryName || "",
        subCategoryName: isDeletedSubCategory ? "" : data.subCategoryName || "",
        category_id: categoryId,
        subcategory_id: subCategoryId,
        is_sensitive: data.is_sensitive || false,
        expires_at: data.expires_at ? dayjs(data.expires_at) : null,
        description: data.description || "",
      });

      if (categoryId) {
        await ensureCategoryLoaded(categoryId);
      }

      if (subCategoryId) {
        await ensureSubCategoryLoaded(subCategoryId);
      }
    }
  } finally {
    setFetchLoading(false);
  }
};
  const validate = () => {
    const newErrors = {};

    if (mode === "add" && !formValues.document) {
      newErrors.document = "File is empty";
    }

    if (!formValues.category_id) {
      newErrors.category = "Category is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFileChange = (file) => {
    if (!file) return false;

    const maxSize = 10 * 1024 * 1024;

    if (file.size > maxSize) {
      setErrors((prev) => ({
        ...prev,
        document: "File size should be below 10 MB",
      }));
      return false;
    }

    setErrors((prev) => ({
      ...prev,
      document: "",
    }));

    setFormValues((prev) => ({
      ...prev,
      document: file,
    }));

    setExistingFileName(file.name);
    return false;
  };

  const handleCategoryScroll = (event) => {
    if (!isDropdownBottom(event)) return;
    if (!categoryHasMore || categoryLoading) return;

    fetchCategories(categoryPage + 1, categorySearch, false);
  };

  const handleSubCategoryScroll = (event) => {
    if (!formValues.category_id) return;
    if (!isDropdownBottom(event)) return;
    if (!subCategoryHasMore || subCategoryLoading) return;

    fetchSubCategories(subCategoryPage + 1, subCategorySearch, false);
  };

  const openAddCategoryModal = () => {
    setEditingCategory(null);
    setCategoryForm({
      category_name: "",
      category_code: "",
      description: "",
      is_active: true,
    });
    setCategoryModalOpen(true);
  };

  const openAddSubCategoryModal = () => {
    if (!formValues.category_id) {
      message.warning("Select category first");
      return;
    }

    setEditingSubCategory(null);
    setSubCategoryForm({
      category_id: String(formValues.category_id),
      subcategory_name: "",
      subcategory_code: "",
      description: "",
      is_active: true,
    });
    setSubCategoryModalOpen(true);
  };

  const handleEditCategory = async (item) => {
    const id = getCategoryId(item);

    if (!id) {
      message.error("Category id missing");
      return;
    }

    setCategoryByIdLoading(true);

    try {
      const result = await GetDocumentCategoryById(id);
      const data = getResponseData(result);

      setEditingCategory(data);

      setCategoryForm({
        category_name: data?.category_name || "",
        category_code: data?.category_code || "",
        description: data?.description || "",
        is_active: data?.is_active ?? true,
      });

      setCategoryModalOpen(true);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch category details");
    } finally {
      setCategoryByIdLoading(false);
    }
  };

  const handleEditSubCategory = async (item) => {
    const id = getSubCategoryId(item);

    if (!id) {
      message.error("Sub category id missing");
      return;
    }

    setSubCategoryByIdLoading(true);

    try {
      const result = await GetDocumentSubCategoryById(id);
      const data = getResponseData(result);

      setEditingSubCategory(data);

      setSubCategoryForm({
        category_id: data?.category_id ? String(data.category_id) : "",
        subcategory_name:
          data?.subcategory_name || data?.sub_category_name || "",
        subcategory_code:
          data?.subcategory_code || data?.sub_category_code || "",
        description: data?.description || "",
        is_active: data?.is_active ?? true,
      });

      setSubCategoryModalOpen(true);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch sub category details");
    } finally {
      setSubCategoryByIdLoading(false);
    }
  };

  const handleDeleteCategory = async (item) => {
    const id = getCategoryId(item);

    if (!id) {
      message.error("Category id missing");
      return;
    }

    try {
      await DeleteDocumentCategory(id);

      if (String(formValues.category_id) === String(id)) {
        setFormValues((prev) => ({
          ...prev,
          category_id: "",
          subcategory_id: "",
        }));
      }

      message.success("Category deleted");
      fetchCategories(1, categorySearch, true);
    } catch (error) {
      console.error(error);
      message.error("Category delete failed");
    }
  };

  const handleDeleteSubCategory = async (item) => {
    const id = getSubCategoryId(item);

    if (!id) {
      message.error("Sub category id missing");
      return;
    }

    try {
      await DeleteDocumentSubCategory(id);

      if (String(formValues.subcategory_id) === String(id)) {
        setFormValues((prev) => ({
          ...prev,
          subcategory_id: "",
        }));
      }

      message.success("Sub category deleted");
      fetchSubCategories(1, subCategorySearch, true);
    } catch (error) {
      console.error(error);
      message.error("Sub category delete failed");
    }
  };

  const confirmDeleteCategory = (item) => {
    Modal.confirm({
      title: "Delete this category?",
      content: getCategoryName(item),
      okText: "Yes",
      cancelText: "No",
      okButtonProps: {
        danger: true,
      },
      onOk: () => handleDeleteCategory(item),
    });
  };

  const confirmDeleteSubCategory = (item) => {
    Modal.confirm({
      title: "Delete this sub category?",
      content: getSubCategoryName(item),
      okText: "Yes",
      cancelText: "No",
      okButtonProps: {
        danger: true,
      },
      onOk: () => handleDeleteSubCategory(item),
    });
  };

  const handleSaveCategory = async () => {
    const payload = {
      category_name: categoryForm.category_name.trim(),
      category_code: categoryForm.category_code.trim(),
      description: categoryForm.description.trim(),
      is_active: categoryForm.is_active,
    };

    if (!payload.category_name) {
      message.warning("Enter category name");
      return;
    }

    // if (!payload.category_code) {
    //   message.warning("Enter category code");
    //   return;
    // }

    setCategoryLoading(true);

    try {
      if (editingCategory) {
        const id = getCategoryId(editingCategory);

        await UpdateDocumentCategory(id, payload);

        message.success("Category updated");
      } else {
        const result = await AddDocumentCategory(payload);
        const savedData = getResponseData(result);
        const savedId = savedData?.category_id
          ? String(savedData.category_id)
          : "";

        if (savedId) {
          setFormValues((prev) => ({
            ...prev,
            category_id: savedId,
            subcategory_id: "",
          }));

          addCategoryIfMissing(savedData);
        }

        setErrors((prev) => ({
          ...prev,
          category: "",
        }));

        message.success("Category added");
      }

      setCategoryModalOpen(false);
      setEditingCategory(null);
      setCategoryForm({
        category_name: "",
        category_code: "",
        description: "",
        is_active: true,
      });

      fetchCategories(1, categorySearch, true);
    } catch (error) {
      console.error(error);
      message.error("Category save failed");
    } finally {
      setCategoryLoading(false);
    }
  };

  const handleSaveSubCategory = async () => {
    const payload = {
      category_id: Number(subCategoryForm.category_id),
      subcategory_name: subCategoryForm.subcategory_name.trim(),
      subcategory_code: subCategoryForm.subcategory_code.trim(),
      description: subCategoryForm.description.trim(),
      is_active: subCategoryForm.is_active,
    };

    if (!payload.category_id) {
      message.warning("Select category");
      return;
    }

    if (!payload.subcategory_name) {
      message.warning("Enter sub category name");
      return;
    }

    // if (!payload.subcategory_code) {
    //   message.warning("Enter sub category code");
    //   return;
    // }

    setSubCategoryLoading(true);

    try {
      if (editingSubCategory) {
        const id = getSubCategoryId(editingSubCategory);

        await UpdateDocumentSubCategory(id, payload);

        message.success("Sub category updated");
      } else {
        const result = await AddDocumentSubCategory(payload);
        const savedData = getResponseData(result);
        const savedId = getSubCategoryId(savedData);

        if (savedId) {
          setFormValues((prev) => ({
            ...prev,
            subcategory_id: String(savedId),
          }));

          addSubCategoryIfMissing(savedData);
        }

        message.success("Sub category added");
      }

      setSubCategoryModalOpen(false);
      setEditingSubCategory(null);
      setSubCategoryForm({
        category_id: "",
        subcategory_name: "",
        subcategory_code: "",
        description: "",
        is_active: true,
      });

      fetchSubCategories(1, subCategorySearch, true);
    } catch (error) {
      console.error(error);
      message.error("Sub category save failed");
    } finally {
      setSubCategoryLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true);

    try {
      const payload = {
        ...formValues,
        category_id: formValues.category_id
          ? Number(formValues.category_id)
          : "",
        subcategory_id: formValues.subcategory_id
          ? Number(formValues.subcategory_id)
          : Number(0),
        is_sensitive: formValues.is_sensitive,
        expires_at: formValues.expires_at
          ? dayjs(formValues.expires_at).format("YYYY-MM-DD")
          : "",
      };

      const result = await UploadDocument(
        payload,
        mode === "edit" ? documentId : null
      );

      if (result?.action === "OTP_REQUIRED") {
        setPendingPayload(payload);
        setOtpModalOpen(true);
        return;
      }

      if (result) {
        GetDocumentsData({
          dispatch,
          page: 1,
          limit: 10,
          type_filter: currentFilter || "",
        });

        onSuccess && onSuccess();
        setModalIsOpen(false);
      }
    } finally {
      // GetAllCategoryDropdown({})
      setLoading(false);
    }
  };

  const handleVerifyUpdateOtp = async (encryptedOtp) => {
    if (!pendingPayload || !documentId) return;

    const result = await ValidateUpdateDocumentOtp(
      documentId,
      pendingPayload,
      encryptedOtp
    );

    if (result) {
      GetDocumentsData({
        dispatch,
        page: 1,
        limit: 10,
        type_filter: currentFilter || "",
      });

      setOtpModalOpen(false);
      setPendingPayload(null);
      onSuccess && onSuccess();
      setModalIsOpen(false);
    }
  };

  const filteredSubCategories = subCategories.filter(
    (item) => String(item.category_id) === String(formValues.category_id)
  );

  const categoryOptions = categories
    .map((item) => {
      const id = getCategoryId(item);
      const name = getCategoryName(item);

      if (!id || !name) return null;

      return {
        value: String(id),
        search: name,
        selectedLabel: name,
        label: (
          <div className="flex items-center justify-between gap-[0.5vw] text-[1vw] px-[0.2vw] pb-[0.1vw] font-normal">
            <span className="truncate">{name}</span>

            <span className="flex items-center gap-[0.5vw]">
              <MdEdit
                size="1vw"
                className="text-[#1F4B7F] cursor-pointer"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleEditCategory(item);
                }}
              />

              <MdDelete
                size="1vw"
                className="text-[#1F4B7F] cursor-pointer"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  confirmDeleteCategory(item);
                }}
              />
            </span>
          </div>
        ),
      };
    })
    .filter(Boolean);

  const subCategoryOptions = filteredSubCategories
    .map((item) => {
      const id = getSubCategoryId(item);
      const name = getSubCategoryName(item);

      if (!id || !name) return null;

      return {
        value: String(id),
        search: name,
        selectedLabel: name,
        label: (
          <div className="flex items-center justify-between gap-[0.5vw] text-[1vw] px-[0.2vw] pb-[0.1vw] font-normal">
            <span className="truncate">{name}</span>

            <span className="flex items-center gap-[0.5vw]">
              <MdEdit
                size="1vw"
                className="text-[#1F4B7F] cursor-pointer"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleEditSubCategory(item);
                }}
              />

              <MdDelete
                size="1vw"
                className="text-[#1F4B7F] cursor-pointer"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  confirmDeleteSubCategory(item);
                }}
              />
            </span>
          </div>
        ),
      };
    })
    .filter(Boolean);

  const categoryModalCategoryOptions = categories.map((item) => ({
    value: String(item.category_id),
    label: item.category_name,
  }));

  if (fetchLoading) {
    return (
      <div className="absolute inset-0 flex justify-center items-center z-10">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="h-full relative -mt-[1vw]">
      <div className="flex justify-between items-center mr-[1vw]">
        <div className="text-[1.4vw] text-[#1F4B7F] font-semibold">
          {mode === "edit" ? "UPDATE DOCUMENT" : "UPLOAD DOCUMENT"}
        </div>

        <button
          type="button"
          className="flex text-white text-[1vw] bg-[#1F4B7F] px-[1.4vw] py-[0.55vw] rounded-[0.7vw] items-center justify-center font-semibold"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : mode === "edit" ? "Update" : "Save"}
        </button>
      </div>

      {loading && (
        <div className="absolute inset-0 flex justify-center items-center z-10">
          <Spin size="large" />
        </div>
      )}

      <div className="umselect pt-[1vw]">
        <div className="grid grid-cols-2 gap-[1vw]">
          <div className="relative col-span-1 flex flex-col">
            <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
              Document
              <span className="text-red-500 text-[1vw] pl-[0.2vw]">*</span>
              <span className="text-[#909193] text-[0.8vw] pl-[0.25vw]">
                {`(Max Size: 5MB)`}
              </span>
            </label>

            <ConfigProvider
              theme={{
                token: {
                  colorBorder: "rgba(255, 255, 255, 0)",
                  colorPrimary: "rgba(255, 255, 255, 0)",
                },
              }}
            >
              <Dragger
                accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.webp"
                beforeUpload={handleFileChange}
                showUploadList={false}
                height={"7vw"}
                className="border-r-[0.25vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] border-[#1F487C] rounded-[0.5vw]"
                style={{
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative",
                }}
              >
                <label className="flex items-center justify-center relative z-10 cursor-pointer h-full">
                  <p className="text-[#1F4B7F] font-bold text-[1.1vw] pr-[1vw]">
                    Drag and Drop
                  </p>
                  <FaUpload color="#1F4B7F" size={"1.2vw"} />
                </label>
              </Dragger>
            </ConfigProvider>

            {errors.document && (
              <p className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] bg-white w-full z-20">
                {errors.document}
              </p>
            )}

            {existingFileName && !errors.document && (
              <p className="text-[#1F4B7F] text-[0.8vw] mt-2 absolute bottom-[-1.3vw] bg-white w-full z-50 truncate">
                {existingFileName}
              </p>
            )}
          </div>

          <div className="relative col-span-1 flex flex-col">
            <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
              Description
            </label>

            <textarea
              value={formValues.description}
              onChange={(e) => {
                const rawValue = e.target.value;
                const cleanedValue = rawValue
                  .replace(/^\s+/, "")
                  .replace(/\s{2,}/g, " ")
                  .replace(
                    /[^A-Za-z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?\s]/g,
                    ""
                  );

                setFormValues((prev) => ({
                  ...prev,
                  description: cleanedValue,
                }));
              }}
              placeholder="Enter Description"
              rows="4"
              cols="50"
              className="border-r-[0.25vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] border-[#1F487C] text-[#1F487C] text-[1vw] w-full h-[7vw] rounded-[0.5vw] outline-none px-[1vw] pt-[0.5vw] placeholder:text-[1vw] placeholder:font-sans resize-none"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-[1vw] pt-[1.2vw]">
          <div className="relative col-span-1 flex flex-col">
            <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
              Category
              <span className="text-red-500 text-[1vw] pl-[0.2vw]">*</span>
            </label>

            <ConfigProvider theme={selectTheme}>
              <Select
                value={formValues.category_id || undefined}
                placeholder="Select Category"
                className={selectClassName}
                showSearch
                filterOption={false}
                listHeight={130}
                optionLabelProp="selectedLabel"
                onSearch={(value) => {
                  setCategorySearch(value);
                  fetchCategories(1, value, true);
                }}
                onPopupScroll={handleCategoryScroll}
                dropdownRender={(menu) => (
                  <>
                    <div
                      className="text-[1vw] px-[0.8vw] py-[0.45vw] font-semibold text-[#1F4B7F] cursor-pointer hover:bg-[#e5e5e5]"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCategorySearch("");
                        openAddCategoryModal();
                      }}
                    >
                      + Add Category
                    </div>

                    {menu}
                  </>
                )}
                onChange={(value) => {
  setErrors((prev) => ({
    ...prev,
    category: "",
  }));

setFormValues((prev) => ({
  ...prev,
  category_id: value,
  subcategory_id: "",
  categoryName: "",
  subCategoryName: "",
}));

  setSubCategorySearch("");
}}
                getPopupContainer={() => document.body}
dropdownStyle={{
  zIndex: 5000,
  maxHeight: "min(240px, 40vh)",
  overflowY: "auto",
}}
                suffixIcon={
                  <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                    <IoMdArrowDropdown size="2vw" />
                  </span>
                }
                style={{ padding: 4 }}
                options={categoryOptions}
              />
            </ConfigProvider>

            {errors.category && (
              <p className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] bg-white w-full z-20">
                {errors.category}
              </p>
            )}
          </div>

          <div className="relative col-span-1 flex flex-col">
            <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
              Sub Category
            </label>

            <ConfigProvider theme={selectTheme}>
              <Select
                value={formValues.subcategory_id || undefined}
                placeholder={
                  formValues.category_id
                    ? "Select Sub Category"
                    : "Select Category First"
                }
                disabled={!formValues.category_id}
                className={selectClassName}
                showSearch
                listHeight={130}
                filterOption={false}
                optionLabelProp="selectedLabel"
                onSearch={(value) => {
                  if (!formValues.category_id) return;
                  setSubCategorySearch(value);
                  fetchSubCategories(1, value, true);
                }}
                onPopupScroll={handleSubCategoryScroll}
                onChange={(value) => {
setFormValues((prev) => ({
  ...prev,
  subcategory_id: value,
  subCategoryName: "",
}));
}}
                getPopupContainer={() => document.body}
dropdownStyle={{
  zIndex: 5000,
  maxHeight: "min(240px, 40vh)",
  overflowY: "auto",
}}
                suffixIcon={
                  <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                    <IoMdArrowDropdown size="2vw" />
                  </span>
                }
                dropdownRender={(menu) => (
                  <>
                    <div
                      className="text-[1vw] px-[0.8vw] py-[0.45vw] font-semibold text-[#1F4B7F] cursor-pointer hover:bg-[#e5e5e5]"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setSubCategorySearch("");
                        openAddSubCategoryModal();
                      }}
                    >
                      + Add Sub Category
                    </div>

                    {menu}
                  </>
                )}
                style={{ padding: 4 }}
                options={subCategoryOptions}
              />
            </ConfigProvider>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-[1vw] pt-[1.2vw]">
          <div className="relative col-span-1 flex flex-col">
            <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
              Expiry Date
            </label>

            <ConfigProvider
              theme={{
                token: {
                  fontSize: ".9vw",
                  lineHeight: 0,
                  colorPrimary: "#1F487C",
                },
                components: {
                  DatePicker: {
                    activeBorderColor: "#1F487C",
                    hoverBorderColor: "#1F487C",
                    activeShadow: "#1F487C",
                    cellWidth: 25,
                    cellHeight: 20,
                  },
                },
              }}
            >
              <DatePicker
                value={formValues.expires_at}
                onChange={(date) => {
                  setErrors((prev) => ({
                    ...prev,
                    expires_at: "",
                  }));
                  setFormValues((prev) => ({
                    ...prev,
                    expires_at: date,
                  }));
                }}
                format="YYYY-MM-DD"
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
                inputReadOnly={true}
                placeholder="Select Expiry Date"
                className="ads-date border-r-[0.25vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-full rounded-[0.5vw] outline-none px-[1vw] placeholder:text-[1vw]"
              />
            </ConfigProvider>
          </div>

          <div className="relative col-span-1 flex flex-col">
            <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
              Sensitive
            </label>

            <ConfigProvider theme={selectTheme}>
              <Select
                value={formValues.is_sensitive ? "true" : "false"}
                className={selectClassName}
                onChange={(value) =>
                  setFormValues((prev) => ({
                    ...prev,
                    is_sensitive: value === "true",
                  }))
                }
                getPopupContainer={(trigger) => trigger.parentNode}
                dropdownStyle={{ maxHeight: "8vw", overflowY: "auto" }}
                suffixIcon={
                  <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                    <IoMdArrowDropdown size="2vw" />
                  </span>
                }
                style={{ padding: 4 }}
                options={[
                  {
                    value: "false",
                    label: (
                      <div className="text-[1vw] px-[0.2vw] pb-[0.1vw] font-normal">
                        No
                      </div>
                    ),
                    search: "No",
                  },
                  {
                    value: "true",
                    label: (
                      <div className="text-[1vw] px-[0.2vw] pb-[0.1vw] font-normal">
                        Yes
                      </div>
                    ),
                    search: "Yes",
                  },
                ]}
              />
            </ConfigProvider>
          </div>
        </div>
      </div>

      <Modal
        open={categoryModalOpen}
        footer={null}
        centered
        zIndex={3000}
        onCancel={() => {
          setCategoryModalOpen(false);
          setEditingCategory(null);
          setCategoryForm({
            category_name: "",
            category_code: "",
            description: "",
            is_active: true,
          });
        }}
        title={
          <div className="text-[#1F4B7F] text-[1.2vw] font-semibold">
            {editingCategory ? "Edit Category" : "Add Category"}
          </div>
        }
      >
        <div className="flex flex-col gap-[0.8vw]">
          <div>
            <label className="text-[#1F4B7F] text-[0.95vw] font-semibold">
              Category Name
              <span className="text-red-500 text-[1vw] pl-[0.2vw]">*</span>
            </label>

            <input
              value={categoryForm.category_name}
              onChange={(e) => {
                const value = e.target.value;

                setCategoryForm((prev) => ({
                  ...prev,
                  category_name: value,
                }));
              }}
              placeholder="Enter Category Name"
              className={inputClass}
            />
          </div>

          {/* <div>
            <label className="text-[#1F4B7F] text-[0.95vw] font-semibold">
              Category Code
            </label>

            <input
              value={categoryForm.category_code}
              onChange={(e) =>
                setCategoryForm((prev) => ({
                  ...prev,
                  category_code: e.target.value
                    .toUpperCase()
                    .replace(/\s+/g, "_"),
                }))
              }
              placeholder="Enter Category Code"
              className={inputClass}
            />
          </div> */}

          <div>
            <label className="text-[#1F4B7F] text-[0.95vw] font-semibold">
              Description
            </label>

            <textarea
              value={categoryForm.description}
              onChange={(e) =>
                setCategoryForm((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              placeholder="Enter Description"
              rows={3}
              className="box-border border-r-[0.18vw] mt-[0.12vw] border-l-[0.08vw] border-t-[0.08vw] border-b-[0.18vw] border-[#1F487C] text-[#1F487C] text-[0.88vw] w-full h-[4.5vw] rounded-[0.3vw] outline-none px-[0.55vw] py-[0.35vw] placeholder:text-[0.95vw] placeholder:font-sans resize-none"
            />
          </div>

          {/* <div>
            <label className="text-[#1F4B7F] text-[0.95vw] font-semibold">
              Active Status
            </label>

            <ConfigProvider
              theme={{
                components: {
                  Select: {
                    optionActiveBg: "#aebed1",
                    optionSelectedColor: "#FFF",
                    optionSelectedBg: "#e5e5e5",
                    optionHeight: "1.8vw",
                  },
                },
              }}
            >
              <Select
                value={categoryForm.is_active ? "true" : "false"}
                className={selectClass}
                onChange={(value) =>
                  setCategoryForm((prev) => ({
                    ...prev,
                    is_active: value === "true",
                  }))
                }
                options={[
                  {
                    value: "true",
                    label: "Active",
                  },
                  {
                    value: "false",
                    label: "Inactive",
                  },
                ]}
              />
            </ConfigProvider>
          </div> */}

          <div className="flex justify-end pt-[0.5vw]">
            <button
              type="button"
              onClick={handleSaveCategory}
              disabled={categoryLoading || categoryByIdLoading}
              className="bg-[#1F4B7F] text-white px-[1.4vw] py-[0.55vw] rounded-[0.5vw] text-[0.95vw] font-semibold"
            >
              {categoryLoading || categoryByIdLoading
                ? "Loading..."
                : editingCategory
                ? "Update"
                : "Submit"}
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        open={subCategoryModalOpen}
        footer={null}
        centered
        zIndex={3000}
        onCancel={() => {
          setSubCategoryModalOpen(false);
          setEditingSubCategory(null);
          setSubCategoryForm({
            category_id: "",
            subcategory_name: "",
            subcategory_code: "",
            description: "",
            is_active: true,
          });
        }}
        title={
          <div className="text-[#1F4B7F] text-[1.2vw] font-semibold">
            {editingSubCategory ? "Edit Sub Category" : "Add Sub Category"}
          </div>
        }
      >
        <div className="flex flex-col gap-[0.8vw]">
          <div>
            <label className="text-[#1F4B7F] text-[0.95vw] font-semibold">
              Category
            </label>

            <ConfigProvider
              theme={{
                components: {
                  Select: {
                    optionActiveBg: "#aebed1",
                    optionSelectedColor: "#FFF",
                    optionSelectedBg: "#e5e5e5",
                    optionHeight: "1.8vw",
                  },
                },
              }}
            >
              <Select
                value={subCategoryForm.category_id || undefined}
                placeholder="Select Category"
                disabled
                className={selectClass}
                showSearch
                optionFilterProp="label"
                onPopupScroll={handleCategoryScroll}
                onChange={(value) =>
                  setSubCategoryForm((prev) => ({
                    ...prev,
                    category_id: value,
                  }))
                }
                options={categoryModalCategoryOptions}
              />
            </ConfigProvider>
          </div>

          <div>
            <label className="text-[#1F4B7F] text-[0.95vw] font-semibold">
              Sub Category Name
              <span className="text-red-500 text-[1vw] pl-[0.2vw]">*</span>
            </label>

            <input
              value={subCategoryForm.subcategory_name}
              onChange={(e) => {
                const value = e.target.value;

                setSubCategoryForm((prev) => ({
                  ...prev,
                  subcategory_name: value,
                }));
              }}
              placeholder="Enter Sub Category Name"
              className={inputClass}
            />
          </div>

          {/* <div>
            <label className="text-[#1F4B7F] text-[0.95vw] font-semibold">
              Sub Category Code
            </label>

            <input
              value={subCategoryForm.subcategory_code}
              onChange={(e) =>
                setSubCategoryForm((prev) => ({
                  ...prev,
                  subcategory_code: e.target.value
                    .toUpperCase()
                    .replace(/\s+/g, "_"),
                }))
              }
              placeholder="Enter Sub Category Code"
              className={inputClass}
            />
          </div> */}

          <div>
            <label className="text-[#1F4B7F] text-[0.95vw] font-semibold">
              Description
            </label>

            <textarea
              value={subCategoryForm.description}
              onChange={(e) =>
                setSubCategoryForm((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              placeholder="Enter Description"
              rows={3}
              className="box-border border-r-[0.18vw] mt-[0.12vw] border-l-[0.08vw] border-t-[0.08vw] border-b-[0.18vw] border-[#1F487C] text-[#1F487C] text-[0.88vw] w-full h-[4.5vw] rounded-[0.3vw] outline-none px-[0.55vw] py-[0.35vw] placeholder:text-[0.95vw] placeholder:font-sans resize-none"
            />
          </div>

          {/* <div>
            <label className="text-[#1F4B7F] text-[0.95vw] font-semibold">
              Active Status
            </label>

            <ConfigProvider
              theme={{
                components: {
                  Select: {
                    optionActiveBg: "#aebed1",
                    optionSelectedColor: "#FFF",
                    optionSelectedBg: "#e5e5e5",
                    optionHeight: "1.8vw",
                  },
                },
              }}
            >
              <Select
                value={subCategoryForm.is_active ? "true" : "false"}
                className={selectClass}
                onChange={(value) =>
                  setSubCategoryForm((prev) => ({
                    ...prev,
                    is_active: value === "true",
                  }))
                }
                options={[
                  {
                    value: "true",
                    label: "Active",
                  },
                  {
                    value: "false",
                    label: "Inactive",
                  },
                ]}
              />
            </ConfigProvider>
          </div> */}

          <div className="flex justify-end pt-[0.5vw]">
            <button
              type="button"
              onClick={handleSaveSubCategory}
              disabled={subCategoryLoading || subCategoryByIdLoading}
              className="bg-[#1F4B7F] text-white px-[1.4vw] py-[0.55vw] rounded-[0.5vw] text-[0.95vw] font-semibold"
            >
              {subCategoryLoading || subCategoryByIdLoading
                ? "Loading..."
                : editingSubCategory
                ? "Update"
                : "Submit"}
            </button>
          </div>
        </div>
      </Modal>

      <DocumentOtpModal
        show={otpModalOpen}
        onClose={() => {
          setOtpModalOpen(false);
          setPendingPayload(null);
        }}
        document={{ document_id: documentId }}
        actionType="update_document"
        onVerifySuccess={handleVerifyUpdateOtp}
      />
    </div>
  );
};

export default DocumentForm;